import {Grid, GridItem} from '@/components/ui/grid-atoms/GridAtoms'
import {Skeleton} from '@/components/ui/skeleton/Skeleton'

export const DiseasesGroupsSelectorLoader = () => {
    return (
        <Grid columns={3} gap={3} fullWidth>
            <GridItem spanColumn={2} direction="column" gap={1.5}>
                <Skeleton width={200} height={20} />
                <Skeleton width="100%" height={32} />
            </GridItem>
        </Grid>
    )
}
